import {
    findLastInstanceAndInsert,
    filteredTeams
} from 'widgets/fixtures/js/utils/helpers';

/**
 * Create an array with bye entries inserted.
 *
 * @param {object} params
 * @param {Array} params.flattenResult flattened match items
 * @param {Array} params.roundsData round data from the API
 * @param {object} params.filters currently selected filters
 * @returns {Array} array with bye objects inserted
 */
export const createArrayWithByes = ({ flattenResult, roundsData, filters }) => {
    let arrayWithByes = [];

    for (const round of roundsData) {
        if (
            round.byes.length &&
            round.byes.some((bye) => bye.id === parseInt(filters.teams))
        ) {
            const newRound = { ...round, isBye: true };
            const teamsWithBye = filteredTeams(newRound, filters);

            if (teamsWithBye.length) {
                arrayWithByes = findLastInstanceAndInsert(
                    flattenResult,
                    newRound
                );
            }
        }
    }

    return arrayWithByes;
};
